import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { TableConstantsModule } from 'src/app/common/constants/tableconstants.module';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { ToastrService } from 'ngx-toastr';
import * as html2pdf from 'html2pdf.js';
import { jsPDF } from "jspdf";
import html2canvas from 'html2canvas';
import { ThrowStmt } from '@angular/compiler';
import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
import { nodeChildrenAsMap } from '@angular/router/src/utils/tree';
import { theme } from 'highcharts';
import { element } from 'protractor';
import { isNullOrUndefined } from 'util';
import {dataSubs,monthmaps,tabledataforstates} from 'src/assets/i18n/hi.json'
@Component({
  selector: 'app-meetingreport-status',
  templateUrl: './meetingreport-status.component.html',
  styleUrls: ['./meetingreport-status.component.css']
})
export class MeetingreportStatusComponent implements OnInit {
  editweightfilter: object = { 'ay': "", 'lu': "", "month": "" };
  timePeriod: any;
  selectedhalfyear: any;
  yearDropDownList: any;
  selectedstate = "ALL"
  selectedQuat: any;
  activeSpinner: boolean;
  timePeriodList: any;
  statelists: any[];
  stateArrayList: any[];
  distrctentityList: any[];
  showdistdrop: any;
  Index = 0;
  sequence=['10','11','12','01','02','03'];
  @Input() selectedlanguage:string;  
  filterdistrict: any;
  // tempTableData:any =[];
  fullData: any;
  selecteddistrict: any;
  monthListArray = ['April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March'];
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  timePeriodObj: any = [
    { key: 'monthly', value: 'Monthly' },
    { key: 'quarterly', value: 'Quarterly' },
    { key: 'halfyearly', value: 'Half Yearly' },
    { key: 'annually', value: 'Annually' }
  ]
  monthsList: any;
  dynamicTimePeriod: any;
  quaterlyList: any;
  showTableData: boolean = false;
  halfyearlyList: any;
  tableDataFormat: any;
  indexData = 0;
  indexNumber: number;
  showprintData: boolean;
  printButton: boolean = false;
  monthsmap: any;
  stateName: any;
  annualMeetingDelay: any[];
  formatValuesObj: any = [];
  formattedData: any[];
  formattedDataDelay: any[];
  selectedYear: any;
  count:number=0;
  // selectedStateId: any;
  constructor(public tableconstants: TableConstantsModule,
    private submitdataSerivce: SubmitdataService,
    private constants: ConstantsModule,
    private utils: UtilsModule,
    private modalService: NgbModal,
    private logsrv: AuthloginService,
    private toastr: ToastrService,) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.getdynamicYears();
    this.timePeriodList = this.timePeriodObj;
    this.getstateslist();
    this.monthsList = this.monthList;
    this.quaterlyList = this.submitdataSerivce.QUATERLY_LIST;
    this.halfyearlyList = this.submitdataSerivce.HALFYEARLY_LIST;
    this.setCurrentMonthDefault()
  }
  initialize_count(){
    this.count=0;
  }
  increment(){
    this.count=this.count+1;
    return this.count;
  }
  getdynamicYears() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if(currentmonth <3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    }   
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });    this.editweightfilter['ay'] = dropDownYear;
  }
  setCurrentMonthDefault() {
    let currentmonth = new Date().getMonth()
    let currentmonthObj;
    this.monthsList.forEach(monthObj => {
      if (parseInt(monthObj['key']) == currentmonth + 1) {
        currentmonthObj = monthObj;
      }
    });
    this.editweightfilter['month'] = currentmonthObj['key'];
  }
  getstateslist() {
    let postdata = {};
    this.stateArrayList = [];
    this.statelists = [];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['BASIN'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata["component"] = "";
    postdata["src"] = "";
    this.submitdataSerivce.getLocationList(postdata).subscribe(data => {
      if (data) {
        this.statelists = [];
        Object.keys(data).forEach(key => {
          data[key].forEach(statelist => {
            this.statelists.push(statelist);
            this.statelists.sort((a, b) => (a.name > b.name) ? 1 : -1);
          });
        })
      }
    });

  }
  changeQuatData(quat) {
    if (quat) {
      this.showTableData = false;
      // if(this.selectedQuat=='q1')

    }
  }
  changeHalfyData(half) {
    if (half) {
      this.showTableData = false;
    }
  }
  setTimePeriod(timeperiod) {
    this.dynamicTimePeriod = timeperiod;
    this.showTableData = false;
    this.showprintData = false;
    this.selectedstate = "ALL";
  }
  showdistrictdropdown(stateuuid) {
    this.showTableData = false;
    // this.selectedId.emit(stateuuid)
  }
  getDistrictList() {
    this.distrctentityList = [];
    // this.selectdistrict = undefined;
    let postdata = {
      'pType': this.constants.LOCATION_CONSTANT['STATE'],
      'cType': this.constants.LOCATION_CONSTANT['DISTRICT'],
      'puuid': this.filterdistrict
    }
    this.submitdataSerivce.getLocationListforUser(postdata).subscribe(data => {
      if (Array.isArray(data)) {
        this.distrctentityList = data;
      }

    }, function (err) {
      this.activespineer = false;
      if (err['error']) {
        this.toastr.error(err['error']['msg'])
      }
    })
  }
  getTableData() {
    this.formattedData = [];
    this.formattedDataDelay =[];
    this.showTableData = true;
    this.showprintData = true;
    let postData = {};
    postData['ay'] = this.editweightfilter['ay'];
    if (this.dynamicTimePeriod == 'quarterly' && this.selectedQuat == 'q1') {
      postData['type'] = "quaterly";
      postData['tp'] = "Q1";
    }
    if (this.dynamicTimePeriod == 'quarterly' && this.selectedQuat == 'q2') {
      postData['type'] = "quaterly";
      postData['tp'] = "Q2";
    }
    if (this.dynamicTimePeriod == 'quarterly' && this.selectedQuat == 'q3') {
      postData['type'] = "quaterly";
      postData['tp'] = "Q3";
    }
    if (this.dynamicTimePeriod == 'quarterly' && this.selectedQuat == 'q4') {
      postData['type'] = "quaterly";
      postData['tp'] = "Q4";
    }
    if (this.dynamicTimePeriod == 'halfyearly' && this.selectedhalfyear == 'h1') {
      postData['type'] = "half yearly";
      postData['tp'] = "H1";
    }
    if (this.dynamicTimePeriod == 'halfyearly' && this.selectedhalfyear == 'h2') {
      postData['type'] = "half yearly";
      postData['tp'] = "H2";
    }
    if (this.dynamicTimePeriod == 'monthly' && this.editweightfilter['month']) {
      postData['type'] = "monthly";
      postData['tp'] = this.editweightfilter['month'];
    }
    if (this.dynamicTimePeriod == 'annually') {
      postData['type'] = "anually";
      postData['tp'] = "A1"
    }
    postData['pUUID'] = this.selectedstate == "ALL" ? "ALL" : this.selectedstate;
    this.submitdataSerivce.getmeetingDelayedData(postData).subscribe(data => {
      this.fullData = data;
      if (!isNullOrUndefined(data)) {
        this.formattedData=[];
        if(this.dynamicTimePeriod == "annually"){
          Object.keys(this.fullData).forEach(stateObj=>{
            let districtList = Object.keys(this.fullData[stateObj]);
            districtList.forEach(district => {
              let temp = [];
              let tempObj = [];
              let updatedData =  this.formatData(this.fullData[stateObj][district]['minutesDelayed']);
              let updatedDataObj = this.formatData(this.fullData[stateObj][district]['meetingDelayed'])
              temp = updatedData;
              tempObj = updatedDataObj;
              this.formattedData.push({"distName":district,"uploadedMinutes":temp,"meetingDelayed":tempObj,"stateName":stateObj});
              this.formattedData.sort((a, b) => (a.distName > b.distName) ? 1 : -1);
          })
          })
        }
      }
    })
  }

  formatData(data) {
    let distData = [];
    let keys = Object.keys(data)
    keys.sort()
    for (let index = 3; index < 12; index++) {
      distData.push(data[keys[index]])
    }
    for (let index = 0; index < 3; index++) {
      distData.push(data[keys[index]])
    }
    return distData;
  }
  printTableData() {
    this.monthList.forEach(element => {
      if (this.editweightfilter['month'] == element['key']) {
        this.monthsmap = element['value'];
      }
    });
    this.statelists.forEach(state => {
      if (this.selectedstate != "ALL") {
        if (this.selectedstate == state['uuid']) {
          this.stateName = state['name']
        }
      } else {
        this.stateName = "ALL STATES";
      }
    })

    let yearVar;
    yearVar = this.editweightfilter['ay'].split('-');
    if(this.editweightfilter['month'] < 4){
      this.selectedYear = yearVar[1];
    }else{
      this.selectedYear = yearVar[0];
    }

    // let label1 = "\t \t \t Meeting Status Report Summary\n"
    if (this.dynamicTimePeriod == "monthly") {
      let labelEn = "Monthly Meeting Status Report Summary for "+ this.monthsmap + " " + this.selectedYear + " for " + this.TitleCaseConverter(this.stateName);
      let labelHi = dataSubs['Monthly'] + " मीटिंग स्थिति रिपोर्ट सारांश के लिए "+ monthmaps[this.monthsmap] + " " + this.selectedYear + " के लिए " + tabledataforstates[this.stateName];
      let label = this.selectedlanguage == 'en'? labelEn : labelHi;
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        //pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(30);
        pdf.text(label,15,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("MonthlyMeetingReport.pdf");
      });
      this.activeSpinner = false;
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 8, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    } else if (this.dynamicTimePeriod == "quarterly" && this.selectedQuat == 'q1') {
      let labelEn = "Quaterly Meeting Status Report Summary for Quater1(April-June) " + yearVar[0] + " for " + this.TitleCaseConverter(this.stateName);
      let labelHi = "पहली तिमाही (अप्रैल-जून) के लिए तिमाही बैठक स्थिति रिपोर्ट सारांश " + yearVar[0] + " के लिए " + tabledataforstates[this.stateName];
      let label = this.selectedlanguage == 'en'? labelEn : labelHi;
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        // pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label,20,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("Q1MeetingReport.pdf");
      });
      this.activeSpinner = false;
      
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 10, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    } else if (this.dynamicTimePeriod == "quarterly" && this.selectedQuat == 'q2') {
      // let assessmentYr = "Assessment Year: " + this.editweightfilter['ay'] + "\t \t \t \t  " + "State : " + this.TitleCaseConverter(this.stateName) + "\n";
      // let monthAndTP = "Time Period: " + this.TitleCaseConverter(this.dynamicTimePeriod) + "\t \t \t \t" +"Quaterly : " + this.selectedQuat.toUpperCase();
      // let label = label1 + assessmentYr + monthAndTP;
      let label = "Quaterly Meeting Status Report Summary for Quater2(July-September) " + yearVar[0] + " for " + this.TitleCaseConverter(this.stateName);
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        //pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label, 20,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("Q2MeetingReport.pdf");
      });
      this.activeSpinner = false;
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 10, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    } else if (this.dynamicTimePeriod == "quarterly" && this.selectedQuat == 'q3') {
      // let assessmentYr = "Assessment Year: " + this.editweightfilter['ay'] + "\t \t \t \t  " + "State : " + this.TitleCaseConverter(this.stateName) + "\n";
      // let monthAndTP = "Time Period: " + this.TitleCaseConverter(this.dynamicTimePeriod) + "\t \t \t \t" +"Quaterly : " + this.selectedQuat.toUpperCase();
      // let label = label1 + assessmentYr + monthAndTP;
      let label = "Quaterly Meeting Status Report Summary for Quater3(October-December) " +yearVar[0]  + " for " + this.TitleCaseConverter(this.stateName);
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        //pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label, 20,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("Q3MeetingReport.pdf");
      });
      this.activeSpinner = false;
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 7, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    } else if (this.dynamicTimePeriod == "quarterly" && this.selectedQuat == 'q4') {
      // let assessmentYr = "Assessment Year: " + this.editweightfilter['ay'] + "\t \t \t \t  " + "State : " + this.TitleCaseConverter(this.stateName) + "\n";
      // let monthAndTP = "Time Period: " + this.TitleCaseConverter(this.dynamicTimePeriod) + "\t \t \t \t \t" +"Quaterly : " + this.selectedQuat.toUpperCase();
      // let label = label1 + assessmentYr + monthAndTP;
      let label = "Quaterly Meeting Status Report Summary for Quater4(January-March) " + yearVar[1] + " for " + this.TitleCaseConverter(this.stateName);
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        //pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label, 20,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("Q4MeetingReport.pdf");
      });
      this.activeSpinner = false;
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 8, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    } else if (this.dynamicTimePeriod == 'halfyearly' && this.selectedhalfyear == 'h1') {
      // let assessmentYr = "Assessment Year: " + this.editweightfilter['ay'] + "\t \t \t \t  " + "State : " + this.TitleCaseConverter(this.stateName) + "\n";
      // let monthAndTP = "Time Period: " + this.TitleCaseConverter(this.dynamicTimePeriod) + "\t \t \t \t \t" +"Half Yearly : " + this.selectedhalfyear.toUpperCase();
      // let label = label1 + assessmentYr + monthAndTP;
      let label = "Half-yearly Meeting Status Report Summary for 1st Half Year(April-September) " + this.editweightfilter['ay']  + " for " + this.TitleCaseConverter(this.stateName);
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        //pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label, 20,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("H1MeetingReport.pdf");
      });
      this.activeSpinner = false;
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 8, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    } else if (this.dynamicTimePeriod == 'halfyearly' && this.selectedhalfyear == 'h2') {
      // let assessmentYr = "Assessment Year: " + this.editweightfilter['ay'] + "\t \t \t \t  " + "State : " + this.TitleCaseConverter(this.stateName) + "\n";
      // let monthAndTP = "Time Period: " + this.TitleCaseConverter(this.dynamicTimePeriod) + "\t \t \t \t \t" +"Half Yearly : " + this.selectedhalfyear.toUpperCase();
      // let label = label1 + assessmentYr + monthAndTP;
      let label = "Half-yearly Meeting Status Report Summary for 2nd Half Year(October- March) " + this.editweightfilter['ay'] + " for " + this.TitleCaseConverter(this.stateName);
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        //pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label, 20,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("H2MeetingReport.pdf");
      });
      this.activeSpinner = false;
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 8, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    } else if (this.dynamicTimePeriod == 'annually') {
      // let assessmentYr = "Assessment Year: " + this.editweightfilter['ay'] + "\t \t \t \t  " + "State : " + this.TitleCaseConverter(this.stateName) + "\n";
      // let monthAndTP =  "Time Period: " + this.TitleCaseConverter(this.dynamicTimePeriod);
      // let label = label1 + assessmentYr + monthAndTP;
      let label =" Annual Meeting Status Report Summary for " + this.TitleCaseConverter(this.stateName);
      this.printButton = true;
      this.activeSpinner = true;
      let DATA = document.getElementById('content');
      this.Index = this.Index + 1;
      html2canvas(DATA).then(function(canvas) {
        canvas.getContext('2d');
         var HTML_Width = canvas.width;
        var HTML_Height = canvas.height;
        var top_left_margin = 15;
        var PDF_Width = HTML_Width+(top_left_margin*2);
        var PDF_Height = (PDF_Width*1.5)+(top_left_margin*2);
        var canvas_image_width = HTML_Width;
        var canvas_image_height = HTML_Height;        
        var totalPDFPages = Math.ceil(HTML_Height/PDF_Height)-1;
        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF('p', 'pt',  [PDF_Width, PDF_Height]);
        //pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin,canvas_image_width,canvas_image_height);

            // ~~~~~~~~ below 3 lines are for heading of the pdf 1st page ~~~~~`
        pdf.setFontSize(20);
        pdf.text(label,300,27);
        pdf.addImage(imgData, 'JPG', top_left_margin, top_left_margin+30,canvas_image_width,canvas_image_height);        
        
        for (var i = 1; i <= totalPDFPages; i++) {           
        pdf.addPage([PDF_Width, PDF_Height]);
        let margin=-(PDF_Height*i)+(top_left_margin*4);
        if(i>1){
        margin=margin+i*8;
        }
        pdf.addImage(imgData, 'JPG', top_left_margin, margin,canvas_image_width,canvas_image_height);
        }        
        pdf.save("AnnualMeetingReport.pdf");
      });
      this.activeSpinner = false;
      // setTimeout(() => {
      //   html2canvas(DATA).then(canvas => {
      //     let fileWidth = 208;
      //     let fileHeight = canvas.height * fileWidth / canvas.width;
      //     const FILEURI = canvas.toDataURL('image/png')
      //     let PDF = new jsPDF('p', 'mm', 'a4');
      //     let position = 30;
      //     PDF.text(label, 25, 15);
      //     PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight)
      //     var today = new Date();
      //     var seconds = today.getMilliseconds();
      //     let filename = "meetingreport.pdf"
      //     PDF.save(filename);
      //     this.activeSpinner = false;

      //   });
      // }, 200);
    }
  }
  TitleCaseConverter(str) {
    return str.replace(
      /\w\S*/g,
      function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );
  }
}
